// NEXARA Livestock i18n — Spanish + English
// NOTE: This file contains UI field labels ONLY. Any "password" / "contraseña"
// strings below are form LABELS, not credentials. No secrets are stored here.
export const translations = {
    es: {
        // Brand
        brand: "NEXARA Livestock",
        tagline: "From Feed to Performance",
        // System / benchmarks
        production_system: "Sistema productivo",
        sys_feedlot: "Estabulado",
        sys_semi: "Semi-estabulado",
        sys_pasture: "Pastoreo",
        diet_type: "Tipo de dieta",
        diet_type_optional: "Tipo de dieta (opcional)",
        diet_placeholder: "Ej: Pradera + suplemento",
        period_override: "Sobrescribir solo este período (opcional)",
        duration_days: "Duración",
        days: "días",
        benchmark: "Benchmark",
        bench_excellent: "Excelente",
        bench_good: "Bueno",
        bench_regular: "Regular",
        bench_bad: "Malo",
        bench_na: "N/A",
        system_averages: "Promedios por sistema",
        system_averages_desc: "FCR comparado solo dentro del mismo sistema productivo. Se muestran los animales más eficientes y más deficientes de cada sistema.",
        most_efficient: "Más eficientes",
        most_deficient: "Más deficientes",
        benchmarks_title: "Tabla de benchmarks (kg alim. / kg ganado)",
        // Auth
        login_title: "Iniciar sesión",
        login_subtitle: "Accede al panel de eficiencia.",
        login_hero_title: "Del alimento al rendimiento.",
        login_hero_desc: "Calcula la Tasa de Conversión Alimenticia en base bruta y materia seca — tanto por kg de peso como por litro de leche.",
        email: "Correo electrónico",
        password: "Contraseña",
        enter: "Entrar",
        no_account: "¿No tienes cuenta?",
        create_account: "Crear cuenta",
        have_account: "¿Ya tienes cuenta?",
        login: "Inicia sesión",
        register_title: "Crear cuenta",
        register_subtitle: "Gestiona tu ganado con eficiencia.",
        name: "Nombre",
        welcome: "Bienvenido",
        demo: "Demo",
        session: "Sesión",
        logout: "Cerrar sesión",
        exit: "Salir",
        // Nav
        nav_dashboard: "Panel",
        nav_animals: "Animales",
        nav_feed: "Alimento",
        nav_weighings: "Pesajes",
        nav_milk: "Producción láctea",
        nav_reports: "Reportes FCR",
        nav_settings: "Ajustes",
        // Dashboard
        dashboard_title: "Panel general",
        dashboard_subtitle: "Eficiencia alimenticia — FCR bruto y materia seca.",
        active_animals: "Animales activos",
        total_reports: "Reportes FCR",
        avg_fcr_as_fed: "FCR promedio (bruto)",
        avg_fcr_dry_matter: "FCR promedio (mat. seca)",
        over_n_reports: "sobre {n} reportes",
        low_efficiency_alerts: "Alertas de baja eficiencia",
        threshold: "Umbral",
        greater_than: "mayor a",
        lot_averages: "Promedios por lote",
        lot_averages_desc: "FCR medio calculado desde reportes cerrados.",
        ranking_title: "Ranking por eficiencia",
        ranking_desc: "Menor FCR bruto = mejor eficiencia.",
        lot: "Lote",
        animals: "Animales",
        reports: "Reportes",
        fcr_as_fed: "FCR bruto",
        fcr_dry_matter: "FCR mat. seca",
        best_fcr: "Mejor FCR",
        last: "Último",
        rfid: "RFID",
        animal: "Animal",
        no_data: "Sin datos",
        view: "Ver",
        // Animals
        animals_title: "Animales",
        animals_subtitle: "Gestión del inventario vía RFID.",
        new_animal: "Registrar animal",
        new_animal_title: "Nuevo animal",
        name_or_id: "Nombre / ID",
        breed: "Raza",
        birth_date: "Fecha de nacimiento",
        production_weight: "Engorde (peso en kg)",
        production_milk: "Lechería (litros)",
        production_type_label: "Tipo de producción",
        last_weight: "Último peso",
        cycle_start_weight: "Peso inicio ciclo",
        save: "Guardar",
        saving: "Guardando…",
        cancel: "Cancelar",
        confirm_delete_animal: "¿Eliminar este animal?",
        no_animals: "No hay animales registrados",
        register_first_animal: "Registra el primer animal con RFID.",
        animal_created: "Animal registrado",
        animal_deleted: "Animal eliminado",
        // Animal detail
        back_to_animals: "Volver a animales",
        current_cycle: "Ciclo actual",
        cycle_start: "Inicio ciclo",
        no_cycle: "Sin ciclo",
        provisional_gain: "Ganancia provisional",
        accumulated_milk: "Leche acumulada",
        consumption_as_fed: "Consumo (bruto)",
        consumption_dry_matter: "Consumo (mat. seca)",
        sum_as_fed: "Suma as-fed",
        sum_dry_matter: "Suma dry matter",
        no_weighings_yet: "Sin pesajes",
        no_reports_yet: "Aún no hay ciclos cerrados.",
        no_consumption_yet: "Sin consumos registrados.",
        no_birth_date: "Raza no especificada",
        born: "Nacido",
        tab_reports: "Reportes FCR",
        tab_weighings: "Pesajes",
        tab_milk: "Leche",
        tab_events: "Consumo",
        period: "Período",
        initial_w: "P. inicial",
        final_w: "P. final",
        gain: "Ganancia",
        milk_l: "Leche (L)",
        feed_as_fed: "Alim. bruto",
        feed_dry_matter: "Alim. mat. seca",
        origin: "Origen",
        origin_feeder: "comedero",
        origin_parlour: "sala ordeño",
        origin_manual: "manual",
        date: "Fecha",
        weight: "Peso",
        liters: "Litros",
        dm_pct: "% MS",
        // Feed
        feed_title: "Alimento",
        feed_subtitle: "Define la composición y registra el consumo del comedero.",
        active_composition: "Composición activa",
        active_composition_desc: "Usada para calcular la materia seca de cada consumo registrado.",
        total_dm: "% Materia seca total",
        component: "Componente",
        weight_kg: "Peso (kg)",
        dm_percent: "% Materia seca",
        add_component: "Añadir componente",
        save_composition: "Guardar composición",
        composition_saved: "Composición guardada",
        feeder_consumption: "Consumo del comedero",
        feeder_consumption_desc: "Eventos manuales y recibidos por API.",
        register_consumption: "Registrar consumo",
        new_consumption: "Nuevo consumo",
        animal_rfid: "RFID del animal",
        consumed_weight_kg: "Peso consumido (kg)",
        datetime_optional: "Fecha y hora (opcional)",
        register: "Registrar",
        consumption_registered: "Consumo registrado",
        no_consumption_registered: "Sin consumos registrados.",
        // Weighings
        weighings_title: "Pesajes",
        weighings_subtitle: "Registrar un peso cierra el ciclo actual y genera el reporte FCR del período.",
        new_weighing: "Registrar pesaje",
        new_weighing_title: "Nuevo pesaje",
        weight_kg_label: "Peso (kg)",
        register_weighing: "Registrar pesaje",
        weighing_registered: "Pesaje registrado — ciclo reiniciado si aplica",
        no_weighings: "Aún no hay pesajes",
        register_first_weighing: "Registra un pesaje para abrir el primer ciclo.",
        // Milk
        milk_title: "Producción láctea",
        milk_subtitle: "Registra litros de leche y cierra el ciclo para generar el reporte FCR (kg alimento por litro).",
        new_milk: "Registrar ordeño",
        new_milk_title: "Nuevo registro de leche",
        liters_label: "Litros",
        milk_registered: "Ordeño registrado",
        close_cycle: "Cerrar ciclo y calcular FCR",
        close_cycle_title: "Cerrar ciclo de leche",
        close_cycle_desc: "Se calculará el FCR = alimento total / leche total del período y se reiniciará el acumulado.",
        confirm_close: "Confirmar cierre",
        cycle_closed: "Ciclo cerrado — reporte generado",
        no_milk: "Aún no hay registros de leche",
        register_first_milk: "Registra el primer ordeño para abrir un ciclo.",
        // Reports
        reports_title: "Reportes FCR",
        reports_subtitle: "Historial de ciclos cerrados con FCR bruto y materia seca.",
        search_reports: "Buscar por RFID, nombre o lote",
        no_reports: "Sin reportes. Registra al menos dos pesajes o cierra un ciclo de leche.",
        period_end: "Fin de período",
        production: "Producción",
        production_label: "Leche o ganancia",
        total_feed_period: "Comida total del período",
        animal_weighing: "Pesaje del animal",
        conversion_rate: "Tasa de conversión",
        // Settings
        settings_title: "Ajustes",
        settings_subtitle: "Configura el umbral de alerta y el idioma.",
        alert_threshold: "Umbral de alerta",
        alert_threshold_desc: "Animales con FCR bruto mayor al umbral aparecerán como alerta de baja eficiencia.",
        max_fcr: "FCR bruto máximo aceptable",
        settings_saved: "Ajustes guardados",
        language: "Idioma",
        language_desc: "Selecciona el idioma de la interfaz.",
        feeder_endpoint: "Endpoint de ingreso del comedero",
        feeder_endpoint_desc: "El comedero inteligente puede enviar eventos a este endpoint (sin autenticación). En producción, protégelo con una API key.",
        parlour_endpoint_desc: "La sala de ordeño puede enviar litros a este endpoint.",
        loading: "Cargando…",
        // Export
        export_label: "Exportar",
        export_xlsx: "Excel (XLSX)",
        export_csv: "CSV",
        exporting: "Exportando…",
        export_failed: "No se pudo generar el archivo",
        export_ok: "Archivo descargado",
        date_from: "Desde",
        date_to: "Hasta",
        // misc
        sum: "Suma",
    },
    en: {
        brand: "NEXARA Livestock",
        tagline: "From Feed to Performance",
        production_system: "Production system",
        sys_feedlot: "Feedlot",
        sys_semi: "Semi-confined",
        sys_pasture: "Pasture",
        diet_type: "Diet type",
        diet_type_optional: "Diet type (optional)",
        diet_placeholder: "E.g. Pasture + supplement",
        period_override: "Override for this period only (optional)",
        duration_days: "Duration",
        days: "days",
        benchmark: "Benchmark",
        bench_excellent: "Excellent",
        bench_good: "Good",
        bench_regular: "Regular",
        bench_bad: "Bad",
        bench_na: "N/A",
        system_averages: "Averages per system",
        system_averages_desc: "FCR compared only within the same production system. Most efficient and least efficient animals of each system are shown.",
        most_efficient: "Most efficient",
        most_deficient: "Least efficient",
        benchmarks_title: "Benchmark table (kg feed / kg gain)",
        login_title: "Sign in",
        login_subtitle: "Access your efficiency dashboard.",
        login_hero_title: "From feed to performance.",
        login_hero_desc: "Calculate the Feed Conversion Rate on both as-fed and dry matter basis — per kg of weight gain or per liter of milk produced.",
        email: "Email",
        password: "Password",
        enter: "Sign in",
        no_account: "Don't have an account?",
        create_account: "Create account",
        have_account: "Already have an account?",
        login: "Sign in",
        register_title: "Create account",
        register_subtitle: "Manage your livestock efficiently.",
        name: "Name",
        welcome: "Welcome",
        demo: "Demo",
        session: "Session",
        logout: "Sign out",
        exit: "Exit",
        nav_dashboard: "Dashboard",
        nav_animals: "Animals",
        nav_feed: "Feed",
        nav_weighings: "Weighings",
        nav_milk: "Milk production",
        nav_reports: "FCR Reports",
        nav_settings: "Settings",
        dashboard_title: "Overview",
        dashboard_subtitle: "Feed efficiency — as-fed and dry matter FCR.",
        active_animals: "Active animals",
        total_reports: "FCR reports",
        avg_fcr_as_fed: "Avg FCR (as-fed)",
        avg_fcr_dry_matter: "Avg FCR (dry matter)",
        over_n_reports: "over {n} reports",
        low_efficiency_alerts: "Low efficiency alerts",
        threshold: "Threshold",
        greater_than: "greater than",
        lot_averages: "Averages per lot",
        lot_averages_desc: "Average FCR computed from closed reports.",
        ranking_title: "Efficiency ranking",
        ranking_desc: "Lower as-fed FCR = better efficiency.",
        lot: "Lot",
        animals: "Animals",
        reports: "Reports",
        fcr_as_fed: "FCR as-fed",
        fcr_dry_matter: "FCR dry matter",
        best_fcr: "Best FCR",
        last: "Latest",
        rfid: "RFID",
        animal: "Animal",
        no_data: "No data",
        view: "View",
        animals_title: "Animals",
        animals_subtitle: "Inventory management via RFID.",
        new_animal: "Add animal",
        new_animal_title: "New animal",
        name_or_id: "Name / ID",
        breed: "Breed",
        birth_date: "Date of birth",
        production_weight: "Finishing (weight in kg)",
        production_milk: "Dairy (liters)",
        production_type_label: "Production type",
        last_weight: "Last weight",
        cycle_start_weight: "Cycle start weight",
        save: "Save",
        saving: "Saving…",
        cancel: "Cancel",
        confirm_delete_animal: "Delete this animal?",
        no_animals: "No animals registered",
        register_first_animal: "Register the first animal with RFID.",
        animal_created: "Animal created",
        animal_deleted: "Animal deleted",
        back_to_animals: "Back to animals",
        current_cycle: "Current cycle",
        cycle_start: "Cycle start",
        no_cycle: "No cycle",
        provisional_gain: "Provisional gain",
        accumulated_milk: "Accumulated milk",
        consumption_as_fed: "Consumption (as-fed)",
        consumption_dry_matter: "Consumption (dry matter)",
        sum_as_fed: "as-fed sum",
        sum_dry_matter: "dry matter sum",
        no_weighings_yet: "No weighings",
        no_reports_yet: "No closed cycles yet.",
        no_consumption_yet: "No consumption records.",
        no_birth_date: "Breed not specified",
        born: "Born",
        tab_reports: "FCR Reports",
        tab_weighings: "Weighings",
        tab_milk: "Milk",
        tab_events: "Consumption",
        period: "Period",
        initial_w: "Start w.",
        final_w: "End w.",
        gain: "Gain",
        milk_l: "Milk (L)",
        feed_as_fed: "Feed as-fed",
        feed_dry_matter: "Feed dry matter",
        origin: "Source",
        origin_feeder: "feeder",
        origin_parlour: "milking parlour",
        origin_manual: "manual",
        date: "Date",
        weight: "Weight",
        liters: "Liters",
        dm_pct: "% DM",
        feed_title: "Feed",
        feed_subtitle: "Set the composition and log feeder consumption.",
        active_composition: "Active composition",
        active_composition_desc: "Used to calculate dry matter for every recorded consumption.",
        total_dm: "Total dry matter %",
        component: "Component",
        weight_kg: "Weight (kg)",
        dm_percent: "Dry matter %",
        add_component: "Add component",
        save_composition: "Save composition",
        composition_saved: "Composition saved",
        feeder_consumption: "Feeder consumption",
        feeder_consumption_desc: "Manual events and API intake.",
        register_consumption: "Log consumption",
        new_consumption: "New consumption",
        animal_rfid: "Animal RFID",
        consumed_weight_kg: "Consumed weight (kg)",
        datetime_optional: "Date and time (optional)",
        register: "Register",
        consumption_registered: "Consumption registered",
        no_consumption_registered: "No consumption records.",
        weighings_title: "Weighings",
        weighings_subtitle: "Recording a weight closes the current cycle and generates the FCR report.",
        new_weighing: "New weighing",
        new_weighing_title: "New weighing",
        weight_kg_label: "Weight (kg)",
        register_weighing: "Record weighing",
        weighing_registered: "Weighing recorded — cycle reset if applicable",
        no_weighings: "No weighings yet",
        register_first_weighing: "Record a weighing to open the first cycle.",
        milk_title: "Milk production",
        milk_subtitle: "Record milk liters and close the cycle to generate FCR (kg feed per liter).",
        new_milk: "Log milking",
        new_milk_title: "New milk record",
        liters_label: "Liters",
        milk_registered: "Milking logged",
        close_cycle: "Close cycle & compute FCR",
        close_cycle_title: "Close milk cycle",
        close_cycle_desc: "FCR = total feed / total milk for the period will be computed and the cycle reset.",
        confirm_close: "Confirm close",
        cycle_closed: "Cycle closed — report generated",
        no_milk: "No milk records yet",
        register_first_milk: "Log the first milking to open a cycle.",
        reports_title: "FCR Reports",
        reports_subtitle: "Historical closed cycles with as-fed and dry matter FCR.",
        search_reports: "Search by RFID, name or lot",
        no_reports: "No reports. Record at least two weighings or close a milk cycle.",
        period_end: "Period end",
        production: "Production",
        production_label: "Milk or gain",
        total_feed_period: "Total feed in period",
        animal_weighing: "Animal weight",
        conversion_rate: "Conversion rate",
        settings_title: "Settings",
        settings_subtitle: "Configure the alert threshold and language.",
        alert_threshold: "Alert threshold",
        alert_threshold_desc: "Animals with as-fed FCR above the threshold will show as low-efficiency alerts.",
        max_fcr: "Max acceptable as-fed FCR",
        settings_saved: "Settings saved",
        language: "Language",
        language_desc: "Select the interface language.",
        feeder_endpoint: "Feeder ingest endpoint",
        feeder_endpoint_desc: "The smart feeder can POST events to this endpoint (no auth). Protect with an API key in production.",
        parlour_endpoint_desc: "The milking parlour can POST liters to this endpoint.",
        loading: "Loading…",
        // Export
        export_label: "Export",
        export_xlsx: "Excel (XLSX)",
        export_csv: "CSV",
        exporting: "Exporting…",
        export_failed: "Export failed",
        export_ok: "File downloaded",
        date_from: "From",
        date_to: "To",
        sum: "Sum",
    },
};
